import { Card, Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import {
  createStyles,
  Theme,
  withStyles,
  WithStyles
} from '@material-ui/core/styles';

import classnames from 'classnames';
import moment from 'moment-timezone';
import React from 'react';
import JwPlayerLoader from '../../components/UI/JwPlayerLoader/JwPlayerLoader';
import VerticalDivider from '../../components/UI/VerticalDivider/VerticalDivider';
import { IPlayoutScreen, IScreen, IWebRTCConfig } from '../../models/states';
import Clock from './Clock';
import './Fullscreen.css';
import JwPlayer from './JwPlayer';
import VideoJsPlayer from './VideoJsPlayer';
import WebRTCPlayer from './WebRTCPlayer';

declare let jwplayer: any;
// width should monitor from outside
const styles = (theme: Theme) =>
  createStyles({
    root: {},
    gridItem: {
      flexGrow: 0
      // margin: '0 60px 50px 0'
    },
    container: {
      margin: '0 auto',
      display: 'flex',
      flexFlow: 'wrap',
      justifyContent: 'center'
    },
    clock: {
      textAlign: 'center',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '2rem',
      backgroundColor: 'black',
      color: '#f8e200',
      height: '100%'
    },
    loader: {
      width: '4.5rem!important',
      height: '4.5rem!important',
      margin: 'auto'
    },
    playerWrapper: {
      display: 'flex',
      // border: `1px solid ${theme.palette.text.primary}`,
      flexDirection: 'column',
      backgroundColor: theme.tertiaryColors.grey,
      cursor: 'pointer',
      height: '100%',
      '&:hover': {
        opacity: 0.8
      }
    },
    fullHeight: {
      height: '100%'
    },
    error: {
      backgroundColor: theme.colors.error
    },
    warning: {
      backgroundColor: theme.colors.warning
    },
    information: {
      backgroundColor: theme.colors.information
    },
    '@keyframes blinker': {
      from: { opacity: 1 },
      to: { opacity: 0.5 }
    },
    errorWrapper: {
      border: `1px solid ${theme.colors.error}`,
      // animation: `$blinker 1s linear infinite`
      animationName: 'blinker',
      animationDuration: '1000ms',
      animationTimingFunction: 'linear',
      animationIterationCount: 'infinite'
      // animationName: '$blinker',

      // animationDuration: '1s',

      // animationTimingFunction: 'linear',
      // animationIterationCount:'infinite',
    },
    warningWrapper: {
      border: `1px solid ${theme.colors.warning}`
    },
    informationWrapper: {
      border: `1px solid ${theme.colors.information}`,
      animationName: 'blinker',
      animationDuration: '1000ms',
      animationTimingFunction: 'linear',
      animationIterationCount: 'infinite'
    },
    textOuterWrapper: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row',
      padding: '0.5rem 1rem'
    },
    textInnerWrapper: {
      whiteSpace: 'nowrap',
      maxWidth: '30ch',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    blur: {
      filter: 'blur(2px)'
    }
  });

// handle network errors
export const onErrorHandler = (e: any, id: number, urls: string[]) => {
  console.log(e);
  const element = document.querySelector(`#playerDiv${id}`);
  if (e.code === 230002 || e.code === 232002) {
    element.innerHTML = `<div class="wrapper">
    <p class="error">Click here to reload</p>
    </div>`;
    element.addEventListener('click', () => retryAllPlayers(urls));
  }
};

// To retry playing all on network error

const retryAllPlayers = (urls: string[]) => {
  urls.forEach((val, i) => {
    const JWPlayer = jwplayer(`playerDiv${i}`);
    JWPlayer.setup({
      file: val,
      width: 486,
      height: 365,
      autostart: 'viewable',
      mute: true
    });

    JWPlayer.on('error', (e: any) => onErrorHandler(e, i, urls));
  });
};

const FarFieldMonitoring: React.FC<IFarFieldMonitoringOwnProps> = (
  props: IFarFieldMonitoringOwnProps
) => {
  const { classes, isFetching, playoutFeeds } = props;
  const urls = playoutFeeds.map(feed => feed.url);
  const blur = globalThis.UI_CONFIG.blur_data;
  let defaultTimezone = moment.tz.guess();
  if (!defaultTimezone) {
    defaultTimezone = 'Etc/Greenwich';
  }
  const playerWidth = {
    width: `${props.width}rem`,
    minHeight: `${0.75 * props.width}rem`
  };
  const loadingPlaceholder = (
    <div className={classes.container}>
      {[1, 2, 3].map((val, i) => (
        <Grid key={i} item xs className={classes.gridItem}>
          <div style={{ width: '486px', height: '365px' }}>
            <JwPlayerLoader />
          </div>
        </Grid>
      ))}
    </div>
  );
  return (
    <div>
      <Grid container className={classes.root} spacing={16}>
        {isFetching ? (
          loadingPlaceholder
        ) : (
          <React.Fragment>
            {props.screen && props.screen.timezone ? (
              <Grid item xs className={classes.gridItem}>
                <Card
                  style={playerWidth}
                  className={classnames(classes.fullHeight)}
                >
                  <div className={classes.clock}>
                    <Clock
                      timezone={
                        props.screen ? props.screen.timezone : defaultTimezone
                      }
                    />
                  </div>
                </Card>
              </Grid>
            ) : null}
            {playoutFeeds.map((value, i, arr) => {
              const playerId = `playoutSource${i}`;
              const {
                iceServers,
                iceTransportPolicy,
                useWebSocketForWebRTC
              } = props.webRTCConfigHash[value.customer];
              return (
                <Grid key={i} item xs className={classes.gridItem}>
                  <Card
                    style={playerWidth}
                    className={classnames(classes.playerWrapper, {
                      [classes.errorWrapper]:
                        value.status === 'ERROR' && !value.snoozed,
                      [classes.warningWrapper]:
                        value.status === 'WARNING' && value.snoozed,
                      [classes.informationWrapper]: value.snoozed
                    })}
                  >
                    {value.url.indexOf('janus') !== -1 ? (
                      <WebRTCPlayer
                        id={playerId}
                        url={value.url}
                        iceServers={iceServers}
                        iceTransportPolicy={iceTransportPolicy}
                        useWebSocketForWebRTC={useWebSocketForWebRTC}
                      />
                    ) : (
                      <VideoJsPlayer src={value.url} />
                    )}
                    <div
                      onClick={() =>
                        props.onOpenPlayoutFeedSummary(
                          `${value.customer}#${value.feed_code}#${value.headend}`
                        )
                      }
                      className={classnames(classes.textOuterWrapper, {
                        [classes.error]:
                          value.status === 'ERROR' && !value.snoozed,
                        [classes.warning]:
                          value.status === 'WARNING' && !value.snoozed,
                        [classes.information]: value.snoozed,
                        [classes.blur]: blur
                      })}
                    >
                      <Typography
                        className={classes.textInnerWrapper}
                        variant={'caption'}
                      >{`${value.name ? value.name : 'NA'}`}</Typography>
                    </div>
                  </Card>
                </Grid>
              );
            })}
          </React.Fragment>
        )}
      </Grid>
    </div>
  );
};
interface IFarFieldMonitoringOwnProps extends WithStyles<typeof styles> {
  isFetching: boolean;
  playoutFeeds: IPlayoutScreen[];
  width: number;
  key: number;
  tab: number;
  onOpenPlayoutFeedSummary: (playoutFeedId: string) => any;
  screen: IScreen;
  webRTCConfigHash: { [key: string]: IWebRTCConfig };
}
export default withStyles(styles)(FarFieldMonitoring);
